

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('../phoneInputB/directive.js');

require('../phoneInputA/directive.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPhoneInput', {
    tag: 'xo-phone-input',
    template: _template2['default'],

    props: {
        phone: {
            type: 'var',
            optional: false
        },

        showPhoneType: {
            type: 'var',
            optional: true,
            'default': true
        },

        hideWork: {
            type: 'var',
            optional: true,
            'default': false
        },

        token: {
            type: 'var',
            optional: true
        },

        exclude: {
            type: 'var',
            optional: true
        }
    },

    lifecycle: {
        enter: function enter() {

            if ((0, _squid.$feature)('showNewPhoneDesign', false, _squid.$locale.country)) {
                this.treatment = true;
            }

            var throttle = _squid.$config['newPhoneDesignThrottle'] && (_squid.$config['newPhoneDesignThrottle'][_squid.$locale.country] || _squid.$config['newPhoneDesignThrottle']['DEFAULT']);

            var id = _squid.$locale.country + _angular.$rootScope.token;

            this.treatment = throttle !== undefined && (0, _squid.$experiment)('new_phone_design_exp', throttle, id, {}) ? true : false;
        }
    }

});

_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$experiment;

_squid.$config;

_squid.$feature;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/phone/phoneInput/directive.js
// module id = ./components/xo-form-components/src/phone/phoneInput/directive.js
// module chunks = 1